import React, { Fragment } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import { decodeHtmlEntities } from '../../../utils/common';

interface ComparisonTableBodyProps {
  versionComparisonRes: any;
  changedVersionKey: any;
  viewChanges: boolean;
  isLocationInfoOpen: boolean;
  isAdditionalInfoOpen: boolean;
  setLocationInfoOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setAdditionalInfoOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ComparisonTableBody: React.FC<ComparisonTableBodyProps> = ({
  versionComparisonRes,
  changedVersionKey,
  viewChanges,
  isLocationInfoOpen,
  isAdditionalInfoOpen,
  setLocationInfoOpen,
  setAdditionalInfoOpen,
}) => {
  const keys = Object.keys(versionComparisonRes)?.filter((key) => /^v\d+$/.test(key));
  const key1 = keys[0];
  const key2 = keys[1];
  const changedVerKeys = Object.keys(changedVersionKey)?.filter((key) => /^v\d+$/.test(key));
  const changedVerKey = changedVerKeys[1];

  return (
    <Fragment>
    <tr style={{ backgroundColor: "#f5f6f8" }}>
      <td colSpan={3} style={{ fontSize: "1rem", fontWeight: "bold" }}>
        {/* <i className='icon-chevron-down pl-2 pr-2' /> */}
        <i
          className={classnames({
            "rotate-90deg": true,
            "icon-chevron-left": !isLocationInfoOpen,
            "icon-chevron-right": isLocationInfoOpen,
            "pl-2 pr-2": true,
          })}
          onClick={() => {
            setLocationInfoOpen(!isLocationInfoOpen);
          }}
        />
        Location Information
      </td>
    </tr>

    {isLocationInfoOpen && (
      <Fragment>
        {(versionComparisonRes[key1]?.hasOwnProperty("cityDetails") ||
          versionComparisonRes[key2]?.hasOwnProperty("cityDetails")) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.cityDetails && (
                <span className="red-dot-indication">•</span>
              )}
              City
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.cityDetails?.cityName}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.cityDetails?.cityName}
            </td>
          </tr>
        )}
        {(versionComparisonRes[key1]?.hasOwnProperty(
          "preferredLocationDetails"
        ) ||
          versionComparisonRes[key2]?.hasOwnProperty(
            "preferredLocationDetails"
          )) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]
                ?.preferredLocationDetails && (
                <span className="red-dot-indication">•</span>
              )}
              Preferred Locations
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.preferredLocationDetails
                ?.map((x: any) => x?.cityLocName)
                ?.join("\n")}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.preferredLocationDetails
                ?.map((x: any) => x?.cityLocName)
                ?.join("\n")}
            </td>
          </tr>
        )}
        {(versionComparisonRes[key1]?.hasOwnProperty(
          "microMarketDetails"
        ) ||
          versionComparisonRes[key2]?.hasOwnProperty(
            "microMarketDetails"
          )) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.microMarketDetails && (
                <span className="red-dot-indication">•</span>
              )}
              Micro Markets
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.microMarketDetails
                ?.map((x: any) => x?.cityZoneName)
                ?.join("\n")}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.microMarketDetails
                ?.map((x: any) => x?.cityZoneName)
                ?.join("\n")}
            </td>
          </tr>
        )}
        {(versionComparisonRes[key1]?.hasOwnProperty(
          "propertyTypeDetails"
        ) ||
          versionComparisonRes[key2]?.hasOwnProperty(
            "propertyTypeDetails"
          )) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.propertyTypeDetails && (
                <span className="red-dot-indication">•</span>
              )}
              Property Type
            </td>
            <td className="col-4">
              {decodeHtmlEntities(
                versionComparisonRes[key1]?.propertyTypeDetails
                  ?.propertyTypeName || ""
              )}
            </td>
            <td className="col-4">
              {decodeHtmlEntities(
                versionComparisonRes[key2]?.propertyTypeDetails
                  ?.propertyTypeName || ""
              )}
            </td>
          </tr>
        )}
        {(versionComparisonRes[key1]?.hasOwnProperty(
          "projectTypeDetails"
        ) ||
          versionComparisonRes[key2]?.hasOwnProperty(
            "projectTypeDetails"
          )) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.projectTypeDetails && (
                <span className="red-dot-indication">•</span>
              )}
              Project Type
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.projectTypeDetails
                ?.map((x: any) => x?.propertyTypeName)
                ?.join("\n")}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.projectTypeDetails
                ?.map((x: any) => x?.propertyTypeName)
                ?.join("\n")}
            </td>
          </tr>
        )}
      </Fragment>
    )}
    <tr style={{ backgroundColor: "#f5f6f8" }}>
      <td colSpan={3} style={{ fontSize: "1rem", fontWeight: "bold" }}>
        <i
          className={classnames({
            "rotate-90deg": true,
            "icon-chevron-left": !isAdditionalInfoOpen,
            "icon-chevron-right": isAdditionalInfoOpen,
            "pl-2 pr-2": true,
          })}
          onClick={() => {
            setAdditionalInfoOpen(!isAdditionalInfoOpen);
          }}
        />
        Additional Property Information
      </td>
    </tr>

    {isAdditionalInfoOpen && (
      <Fragment>
        {versionComparisonRes[key1]?.leadDetails?.leadIntent?.name && (
          <tr>
            <td className="col-4">Intent</td>
            <td className="col-4">
              {versionComparisonRes[key1]?.leadDetails?.leadIntent?.name ??
                ""}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.leadDetails?.leadIntent?.name ??
                ""}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty("minSeats") ||
          versionComparisonRes[key2]?.hasOwnProperty("minSeats") ||
          versionComparisonRes[key1]?.hasOwnProperty("maxSeats") ||
          versionComparisonRes[key2]?.hasOwnProperty("maxSeats") ||
          !viewChanges) && (
          <tr>
            <td className="col-4">
              {(changedVersionKey[changedVerKey]?.minSeats ||
                changedVersionKey[changedVerKey]?.maxSeats) && (
                <span className="red-dot-indication">•</span>
              )}
              Seats
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.minSeats ?? 0} -{" "}
              {versionComparisonRes[key1]?.maxSeats ?? 0}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.minSeats ?? 0} -{" "}
              {versionComparisonRes[key2]?.maxSeats ?? 0}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty("facilityType") ||
          versionComparisonRes[key2]?.hasOwnProperty("facilityType")) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.facilityType && (
                <span className="red-dot-indication">•</span>
              )}
              Facility Type
            </td>
            <td className="col-4">
              {decodeHtmlEntities(
                versionComparisonRes[key1]?.facilityTypeDetails
                  ?.facilityType || ""
              )}
            </td>
            <td className="col-4">
              {decodeHtmlEntities(
                versionComparisonRes[key2]?.facilityTypeDetails
                  ?.facilityType || ""
              )}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty("minPrice") ||
          versionComparisonRes[key2]?.hasOwnProperty("minPrice") ||
          versionComparisonRes[key1]?.hasOwnProperty("maxPrice") ||
          versionComparisonRes[key2]?.hasOwnProperty("maxPrice") ||
          !viewChanges) && (
          <tr>
            <td className="col-4">
              {(changedVersionKey[changedVerKey]?.minPrice ||
                changedVersionKey[changedVerKey]?.maxPrice) && (
                <span className="red-dot-indication">•</span>
              )}
              Budget(Per Sq. Ft.)
            </td>
            <td className="col-4">
              ₹ {versionComparisonRes[key1]?.minPrice ?? 0} - ₹{" "}
              {versionComparisonRes[key1]?.maxPrice ?? 0}
            </td>
            <td className="col-4">
              ₹ {versionComparisonRes[key2]?.minPrice ?? 0} - ₹{" "}
              {versionComparisonRes[key2]?.maxPrice ?? 0}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty("minArea") ||
          versionComparisonRes[key2]?.hasOwnProperty("minArea") ||
          versionComparisonRes[key1]?.hasOwnProperty("maxArea") ||
          versionComparisonRes[key2]?.hasOwnProperty("maxArea") ||
          !viewChanges) && (
          <tr>
            <td className="col-4">
              {(changedVersionKey[changedVerKey]?.minArea !== undefined &&
                changedVersionKey[changedVerKey]?.minArea !== null &&
                changedVersionKey[changedVerKey]?.minArea !== 0) ||
              (changedVersionKey[changedVerKey]?.maxArea !== undefined &&
                changedVersionKey[changedVerKey]?.maxArea !== null &&
                changedVersionKey[changedVerKey]?.maxArea !== 0) ? (
                <span className="red-dot-indication">•</span>
              ) : null}
              Sq.Ft. Area
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.minArea
                ? `${versionComparisonRes[key1]?.minArea} Sq. Ft.`
                : ""}{" "}
              -
              {versionComparisonRes[key1]?.maxArea
                ? `${versionComparisonRes[key1]?.maxArea} Sq. Ft.`
                : ""}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.minArea
                ? `${versionComparisonRes[key2]?.minArea} Sq. Ft.`
                : ""}{" "}
              -
              {versionComparisonRes[key2]?.maxArea
                ? `${versionComparisonRes[key2]?.maxArea} Sq. Ft.`
                : ""}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty(
          "earliestMoveInDate"
        ) ||
          versionComparisonRes[key2]?.hasOwnProperty(
            "earliestMoveInDate"
          ) ||
          !viewChanges) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.earliestMoveInDate && (
                <span className="red-dot-indication">•</span>
              )}
              Earliest Move-in Date
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.earliestMoveInDate
                ? moment(
                    versionComparisonRes[key1]?.earliestMoveInDate
                  ).format("DD-MM-YYYY")
                : ""}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.earliestMoveInDate
                ? moment(
                    versionComparisonRes[key2]?.earliestMoveInDate
                  ).format("DD-MM-YYYY")
                : ""}
            </td>
          </tr>
        )}
        {(versionComparisonRes[key1]?.hasOwnProperty("lastMoveInDate") ||
          versionComparisonRes[key2]?.hasOwnProperty("lastMoveInDate") ||
          !viewChanges) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.lastMoveInDate && (
                <span className="red-dot-indication">•</span>
              )}
              Last Move-in Date
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.lastMoveInDate
                ? moment(versionComparisonRes[key1]?.lastMoveInDate).format(
                    "DD-MM-YYYY"
                  )
                : ""}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.lastMoveInDate
                ? moment(versionComparisonRes[key1]?.lastMoveInDate).format(
                    "DD-MM-YYYY"
                  )
                : ""}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty(
          "floorPreferenceDetails"
        ) ||
          versionComparisonRes[key2]?.hasOwnProperty(
            "floorPreferenceDetails"
          )) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.floorPreferenceDetails && (
                <span className="red-dot-indication">•</span>
              )}
              Floor Preferences
            </td>

            <td className="col-4">
              {versionComparisonRes[key1]?.floorPreferenceDetails
                ?.slice()
                ?.sort(
                  (a: { floorName: string }, b: { floorName: string }) =>
                    parseInt(a?.floorName, 10) - parseInt(b?.floorName, 10)
                )
                ?.map((x: { floorName: string }) => x?.floorName)
                ?.join("\n")}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.floorPreferenceDetails
                ?.slice()
                ?.sort(
                  (a: { floorName: string }, b: { floorName: string }) =>
                    parseInt(a?.floorName, 10) - parseInt(b?.floorName, 10)
                )
                ?.map((x: { floorName: string }) => x?.floorName)
                ?.join("\n")}
            </td>
          </tr>
        )}
        
        {(versionComparisonRes[key1]?.hasOwnProperty(
          "constructionStatus"
        ) ||
          versionComparisonRes[key2]?.hasOwnProperty(
            "constructionStatus"
          )) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.constructionStatus && (
                <span className="red-dot-indication">•</span>
              )}
              Construction Status
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.constructionStatus
                ?.map(
                  (status: any) =>
                    status?.charAt(0).toUpperCase() +
                    status
                      ?.slice(1)
                      .replace(/([A-Z])/g, " $1")
                      .trim()
                )
                .join("\n")}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.constructionStatus
                ?.map(
                  (status: any) =>
                    status?.charAt(0).toUpperCase() +
                    status
                      ?.slice(1)
                      .replace(/([A-Z])/g, " $1")
                      .trim()
                )
                .join("\n")}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty(
          "constructionCompletionDate"
        ) ||
          versionComparisonRes[key2]?.hasOwnProperty(
            "constructionCompletionDate"
          ) ||
          !viewChanges) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]
                ?.constructionCompletionDate && (
                <span className="red-dot-indication">•</span>
              )}
              Construction Completion Date
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.constructionCompletionDate
                ? moment(
                    versionComparisonRes[key1]?.constructionCompletionDate
                  ).format("DD-MM-YYYY")
                : ""}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.constructionCompletionDate
                ? moment(
                    versionComparisonRes[key1]?.constructionCompletionDate
                  ).format("DD-MM-YYYY")
                : ""}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty("interiorType") ||
          versionComparisonRes[key2]?.hasOwnProperty("interiorType")) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.interiorType && (
                <span className="red-dot-indication">•</span>
              )}
              Interior Type
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.interiorType
                ?.map(
                  (status: any) =>
                    status?.charAt(0).toUpperCase() +
                    status
                      ?.slice(1)
                      .replace(/([A-Z])/g, " $1")
                      .trim()
                )
                .join("\n")}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.interiorType
                ?.map(
                  (status: any) =>
                    status?.charAt(0).toUpperCase() +
                    status
                      ?.slice(1)
                      .replace(/([A-Z])/g, " $1")
                      .trim()
                )
                .join("\n")}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty("includeGradeC") ||
          versionComparisonRes[key2]?.hasOwnProperty("includeGradeC") ||
          !viewChanges) && (
          <tr>
            <td className="col-4">
              {typeof changedVersionKey[changedVerKey]?.includeGradeC ===
                "boolean" && <span className="red-dot-indication">•</span>}
              Include Grade C
            </td>
            <td className="col-4">
              {typeof versionComparisonRes[key1]?.includeGradeC ===
              "boolean"
                ? versionComparisonRes[key1]?.includeGradeC === true
                  ? "Yes"
                  : versionComparisonRes[key1]?.includeGradeC === false &&
                    "No"
                : ""}
            </td>
            <td className="col-4">
              {typeof versionComparisonRes[key2]?.includeGradeC ===
              "boolean"
                ? versionComparisonRes[key2]?.includeGradeC === true
                  ? "Yes"
                  : versionComparisonRes[key2]?.includeGradeC === false &&
                    "No"
                : ""}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty(
          "includeLeaseExpiry"
        ) ||
          versionComparisonRes[key2]?.hasOwnProperty(
            "includeLeaseExpiry"
          ) ||
          !viewChanges) && (
          <tr>
            <td className="col-4">
              {typeof changedVersionKey[changedVerKey]
                ?.includeLeaseExpiry === "boolean" && (
                <span className="red-dot-indication">•</span>
              )}
              Include Lease Expiry Options
            </td>
            <td className="col-4">
              {typeof versionComparisonRes[key1]?.includeLeaseExpiry ===
              "boolean"
                ? versionComparisonRes[key1]?.includeLeaseExpiry === true
                  ? "Yes"
                  : versionComparisonRes[key1]?.includeLeaseExpiry ===
                      false && "No"
                : ""}
            </td>
            <td className="col-4">
              {typeof versionComparisonRes[key2]?.includeLeaseExpiry ===
              "boolean"
                ? versionComparisonRes[key2]?.includeLeaseExpiry === true
                  ? "Yes"
                  : versionComparisonRes[key2]?.includeLeaseExpiry ===
                      false && "No"
                : ""}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty("grade") ||
          versionComparisonRes[key2]?.hasOwnProperty("grade") ||
          !viewChanges) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.grade && (
                <span className="red-dot-indication">•</span>
              )}
              Grade
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.grade
                ? versionComparisonRes[key1]?.grade
                : ""}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.grade
                ? versionComparisonRes[key2]?.grade
                : ""}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty("proposalDueBy") ||
          versionComparisonRes[key2]?.hasOwnProperty("proposalDueBy") ||
          !viewChanges) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.proposalDueBy && (
                <span className="red-dot-indication">•</span>
              )}
              Proposal Due By
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.proposalDueBy
                ? moment(versionComparisonRes[key1]?.proposalDueBy).format(
                    "DD-MM-YYYY"
                  )
                : ""}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.proposalDueBy
                ? moment(versionComparisonRes[key1]?.proposalDueBy).format(
                    "DD-MM-YYYY"
                  )
                : ""}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty("forecast") ||
          versionComparisonRes[key2]?.hasOwnProperty("forecast") ||
          !viewChanges) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.forecast && (
                <span className="red-dot-indication">•</span>
              )}
              Forecast:
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.forecast
                ? versionComparisonRes[key1]?.forecast
                : ""}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.forecast
                ? versionComparisonRes[key2]?.forecast
                : ""}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty("certainity") ||
          versionComparisonRes[key2]?.hasOwnProperty("certainity") ||
          !viewChanges) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.certainity && (
                <span className="red-dot-indication">•</span>
              )}
              Certainity:
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.certainity
                ? versionComparisonRes[key1]?.certainity
                : ""}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.certainity
                ? versionComparisonRes[key2]?.certainity
                : ""}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty(
          "specialRequirements"
        ) ||
          versionComparisonRes[key2]?.hasOwnProperty(
            "specialRequirements"
          ) ||
          !viewChanges) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.specialRequirements && (
                <span className="red-dot-indication">•</span>
              )}
              Special Requirements
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.specialRequirements
                ? versionComparisonRes[key1]?.specialRequirements
                : ""}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.specialRequirements
                ? versionComparisonRes[key2]?.specialRequirements
                : ""}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty(
          "coreRequirements"
        ) ||
          versionComparisonRes[key2]?.hasOwnProperty(
            "coreRequirements"
          ) ||
          !viewChanges) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.coreRequirements && (
                <span className="red-dot-indication">•</span>
              )}
              Core Requirement
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.coreRequirements
                ? versionComparisonRes[key1]?.coreRequirements.join(', ')
                : ""}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.coreRequirements
                ? versionComparisonRes[key2]?.coreRequirements.join(', ')
                : ""}
            </td>
          </tr>
        )}

        {(versionComparisonRes[key1]?.hasOwnProperty(
          "coreRequirementParameters"
        ) ||
          versionComparisonRes[key2]?.hasOwnProperty(
            "coreRequirementParameters"
          ) ||
          !viewChanges) && (
          <tr>
            <td className="col-4">
              {changedVersionKey[changedVerKey]?.coreRequirementParameters && (
                <span className="red-dot-indication">•</span>
              )}
              Requirement Parameters
            </td>
            <td className="col-4">
              {versionComparisonRes[key1]?.coreRequirementParameters
                ? versionComparisonRes[key1]?.coreRequirementParameters.join(', ')
                : ""}
            </td>
            <td className="col-4">
              {versionComparisonRes[key2]?.coreRequirementParameters
                ? versionComparisonRes[key2]?.coreRequirementParameters.join(', ')
                : ""}
            </td>
          </tr>
        )}
      </Fragment>
    )}
  </Fragment>
  );
};

export default ComparisonTableBody;